var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.ImageVectorSource = new Class({
    Extends: OCS.Viewer.Classes.VectorSource,
    class_name: "ImageVectorSource",
    vector_source: null,
    options: {
        metadata: {
            source_type: 'ImageVector'
        }
    },
    style_method: null,
    create: function () {
        if (!this.get_ol_object()) {
            this.destroy_source();
            this.set_ol_object(new ol.source.ImageVector(this.get_source_ops()));
        }
        return this.get_ol_object();
    },
    clear: function () {

    },    
    get_source_ops: function () {
        var ops = {
            projection: this.options.projection,
        };
        var vs = this.get_vector_source();
        ops.source = vs.get_source();


        if (this.options.hasOwnProperty('style')) {
            this.set_style_method(this.options.style);
        }
        var style = this.style_method;
        if (!this.style_method) {
            style = function (feature, resolution) {
                var featureStyleFunction = feature.getStyleFunction();
                if (featureStyleFunction) {
                    return featureStyleFunction.call(feature, resolution);
                }
                return {};
            };
        }
        ops.style = style;

        if (this.options.hasOwnProperty('ratio')) {
            ops.ratio = this.options.ratio;
        }
        if (this.options.hasOwnProperty('render_buffer')) {
            ops.renderBuffer = this.options.render_buffer;
        }
        if (this.options.hasOwnProperty('resolutions')) {
            ops.resolutions = this.options.resolutions;
        }
        return ops;
    },
    get_vector_source: function () {
        if (!this.vector_source) {
            this.vector_source = new OCS.Viewer.Classes.VectorSource();
            this.vector_source.addEvent('features_added', this.data_source_ready.bind(this));
        }
        return this.vector_source;
    },
    set_style_method: function (method) {
        this.style_method = method;
        var obj = this.get_ol_object();
        if (obj) {
            obj.setStyle(method);
        }
    },
    set_vector_source: function (vec) {
        this.vector_source = vec;
    },
    set_data: function (data) {
        if (this.vector_source) {
            this.vector_source.set_data(data);
        } else {
            this.parent(data);
        }
    },

    add_feature: function (feature) {
        var vs_source = this.get_vector_source();
        vs_source.add_feature(feature);
        setTimeout(function () {
            this.get_source().changed();
        }.bind(this), 0);
    },
    add_features: function (features) {
        var vs_source = this.get_vector_source();
        vs_source.add_features(features);
        setTimeout(function () {
            this.get_source().changed();
        }.bind(this), 0);
    },
    remove_feature: function (feature) {
        var vs_source = this.get_vector_source();
        vs_source.remove_feature(feature);
        this.get_source().changed();
    },
    valueFromLonLat: function (mouse_position) {
        var vs_source = this.get_vector_source();
        return vs_source.valueFromLonLat(mouse_position);
    },
    destroy: function () {
        if (this.vector_source) {
            this.vector_source.destroy();
            this.vector_source = null;
        }
        this.parent();
    }
});
